module.exports = __webpack_public_path__ + "img/store-close.b0e5810b.png";